import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Component } from 'react';
import 'Home/Components/LeaderboardDetails/leaderboarddetails.css';
import config from 'config';
import HomeApiCall from 'HomeApiCall';
import ButtonLoader from 'Home/CommonResources/ButtonLoader/ButtonLoader';
import { Base64 } from "js-base64";

class LeaderboardDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // VARIABLES TO GET LEADERBOARD DETAILS
            fetchingLeaderboard: false,
            CreditHistory: {},
            CreditHistorySequenceIdArray: [],
            academicYear: this.props.academicYear != undefined ? this.props.academicYear : '',
            department: this.props.department != undefined ? this.props.department : '', // Added department to state
            facultyTotalPoints: '',
        };
    }
    componentDidMount() {
        // METHOD CALLED TO GET CREDIT HISTORY
        this.apiCallToGetLeaderboardCreditHistory();
    }

 // Updated componentDidUpdate to detect changes in academicYear or department props
    componentDidUpdate(prevProps) {
        // Check if academicYear or department prop has changed
        if (prevProps.academicYear !== this.props.academicYear || prevProps.department !== this.props.department) {
            // Update state with new academicYear and department, then trigger data fetch
            this.setState(
                {
                    academicYear: this.props.academicYear,
                    department: this.props.department
                },
                () => {
                    this.apiCallToGetLeaderboardCreditHistory();
                }
            );
        }
    }
    
    // API CALL METHOD TO GET CREDIT HISTORY
    apiCallToGetLeaderboardCreditHistory = async () => {
        this.setState({
            fetchingLeaderboard: true
        });

        let requestData = {
            'aca_yr': this.state.academicYear,
            'facultyId': config.faculty_id,
            'pageIndex': 1,
            'limitPerPage': 5,
            'iid': config.institute_id
        };

        let jsonResponse = await HomeApiCall.makeApiCall(
            'getLeaderboardCreditHistory',
            requestData,
            '/api/leaderboard/leaderboard.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetLeaderboardCreditHistory();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;

                this.setState({
                    CreditHistory: apiResult.allFacultiesPointHistory,
                    facultyTotalPoints: jsonResponse.APIResult.facultyTotalPoints,
                    fetchingLeaderboard: false,
                    CreditHistorySequenceIdArray: jsonResponse.APIResult.sequenceIdArrayForAllFaculty
                });

                function setCookie(name, value) {
                    document.cookie = name + "=" + (value || "")+";path=/; ";
                }
                function setWcCookie(name,value) {
                    document.cookie = name + "=" + (value || "") + "; path=/;domain=.vmedulife.com";
                }
        
                var InstructorDetailsJSON = JSON.parse(Base64.decode(Base64.decode(this.getCookie("user_details_wc"))));
                InstructorDetailsJSON["data"]["Points"] = jsonResponse.APIResult.facultyTotalPoints;
                setCookie("user_details",Base64.encode(Base64.encode(JSON.stringify(InstructorDetailsJSON))) );
                setWcCookie("user_details_wc",Base64.encode(Base64.encode(JSON.stringify(InstructorDetailsJSON))) );
                
                // window.location.replace(config.RootUrl + '/modules/summary/#/');
                // window.location.replace('http://localhost:3000/');
            }
        }
    }

    //function to get token cookies 00
    getCookie = (cname)=> {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for(var i = 0; i <ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
            c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    render() {
        return (
            <div className="leaderboardDetails">
                <a href={`${config.RootUrl}/modules/leaderboard/#/`}>
                    <p style={{ fontSize: 15, fontWeight: 'bold', color: '#2979FF' }}>Leaderboard</p>
                </a>
                <div className="facultyDetails" >
                    <span>{config.instructorName}</span>
                    <span className="facultyPoints">{this.state.facultyTotalPoints}</span>
                </div>
                <div className="Leaderboard">
                    {
                        this.state.fetchingLeaderboard ?
                            <ButtonLoader />
                            :
                            <div className="creditHistory">
                                {
                                    this.state.CreditHistorySequenceIdArray.length > 0 ?
                                        this.state.CreditHistorySequenceIdArray.map((id, index) => {
                                            let credit = this.state.CreditHistory[id];
                                            let color = credit.operation == "ADD" ? "#42ad94" : "rgb(235, 87, 87)";
                                            let backgroundColor = credit.operation == "ADD" ? "#dceddd" : "rgb(254, 232, 231)";
                                            return (
                                                <div className="creditCard">
                                                    <div className="InstructorDetails">
                                                        <div className="creditName text-truncate">{credit.details}</div>
                                                        <div className="facultyName text-truncate">{credit.facultyName}</div>
                                                        <div className="creditScore" style={{ color: color }}>{credit.points} Credit | {credit.moduleName}</div>
                                                        <div className="creditDate">{credit.pointAddedOn}</div>
                                                    </div>
                                                    <div className="CreditDetails">
                                                        <div className="creditAddSub">
                                                            <div className="CreditIconContainer" style={{ background: backgroundColor }}>
                                                                <FontAwesomeIcon icon={['fas', credit.operation == "ADD" ? "arrow-up" : "arrow-down"]} color={color} />
                                                            </div>
                                                            <div className="CreditDynamicStatic" style={{ color: color }}>{credit.type}</div>
                                                        </div>
                                                        <div className="PointsDetails">
                                                            {/* <div className="creditScoreContainer">
                                                
                                                <div className="module-name card">{credit.moduleName}</div>
                                            </div>
                                            <div className="creditDate">{credit.pointAddedOn}</div> */}
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })
                                        :
                                        <p>Credit history is not available.</p>
                                }
                            </div>
                    }
                </div>
            </div>
        );
    }
}

export default LeaderboardDetails;